module.exports = __webpack_public_path__ + "img/colorFullWhiteText.5e899fb7.svg";